<template>
  <Navbar :title="title" :class="{'show' : showNavbar}">
    <template v-slot:close>
      <div @click="$emit('close')" class="close">
        Cerrar
      </div>
    </template>
    <template v-slot:content>
      <!--Tenant context (read-only)-->
      <div class="form-group">
        <label>Inquilino</label>
        <input class="input" type="text" :value="data.alias || data.name || '-'" readonly disabled>
      </div>
      <!--Email-->
      <div class="form-group">
        <label for="email">Email</label>
        <input v-model.trim="form.email" class="input" type="email" id="email" maxlength="120">
        <span v-if="this.validationErrors.email" class="error">{{ this.validationErrors.email }}</span>
      </div>
      <!--Password-->
      <div class="form-group">
        <label for="password">Contraseña temporal</label>
        <input v-model.trim="form.password" class="input" type="text" id="password" maxlength="64">
        <span v-if="this.validationErrors.password" class="error">{{ this.validationErrors.password }}</span>
        <div @click="generatePassword" class="generate-password">Generar contraseña</div>
      </div>
    </template>
    <template v-slot:footer>
      <button :disabled="progress" :class="{'is-loading': progress}" @click="grant" class="btn">
        <span v-if="!progress">Crear acceso</span>
      </button>
    </template>
  </Navbar>
  <Shadow :class="{'show' : showNavbar}"/>
</template>

<script>
import Navbar from '@/components/Navbar'
import Shadow from '@/components/Shadow'
import { functions } from '@/firebase/firebaseConfig'
import * as yup from 'yup'

yup.setLocale({
  mixed: {
    required: 'Este campo es obligatorio'
  },
  string: {
    email: 'Debe ser un email'
  }
})

export default {
  name: 'AccessTenant',
  props: {
    showNavbar: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    title: {
      type: String
    },
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Navbar,
    Shadow
  },
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      schema: yup.object().shape({
        email: yup.string().email().required().max(120, 'Máximo 120 caracteres').label('Email'),
        password: yup.string().required().min(6, 'Mínimo 6 caracteres').max(64, 'Máximo 64 caracteres').label('Contraseña')
      }),
      validationErrors: {},
      progress: false
    }
  },
  watch: {
    showNavbar (value) {
      if (value) {
        this.form = {
          email: this.data.email || '',
          password: ''
        }
        this.validationErrors = {}
      }
    }
  },
  methods: {
    generatePassword () {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'
      let password = ''
      for (let i = 0; i < 12; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.form.password = password
    },
    async grant () {
      try {
        this.progress = true
        this.validationErrors = {}
        await this.schema.validate({ ...this.form }, { abortEarly: false })
        const callable = functions.httpsCallable('exhibitors-createExhibitorAccount')
        const result = await callable({
          clientId: this.data.id,
          email: this.form.email,
          password: this.form.password
        })
        this.$toast.success('Acceso creado')
        this.$emit('granted', {
          clientId: this.data.id,
          uid: result.data.uid,
          email: this.form.email
        })
        this.form = {
          email: '',
          password: ''
        }
        this.$emit('close')
      } catch (err) {
        if (err.inner) {
          err.inner.forEach(error => {
            if (error.path) {
              this.validationErrors[error.path] = error.message
            }
          })
        } else {
          this.handleError(err)
        }
        console.log(err)
      } finally {
        this.progress = false
      }
    },
    handleError (err) {
      switch (err.code) {
        case 'functions/permission-denied':
          this.$toast.error('No tienes permiso para crear accesos')
          break
        case 'functions/invalid-argument':
          this.$toast.error('Datos inválidos, revisa el email y la contraseña')
          break
        case 'functions/not-found':
          this.$toast.error('No se encontró el inquilino')
          break
        default:
          this.$toast.error('Error al crear el acceso')
      }
    }
  }
}
</script>

<style scoped>
.generate-password {
  display: inline-block;
  margin-top: 8px;
  font-size: 13px;
  color: #B51A3E;
  cursor: pointer;
  text-decoration: underline;
}
</style>
